import React from 'react';

const IconTicket1: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M40.3424 28.5352C40.3424 26.8975 41.5323 25.5698 43 25.5698V21.9657C41.5323 21.9657 40.3424 20.6379 40.3424 19C40.3424 17.3623 41.5323 16.0346 43 16.0346V13.2761C43 12.0192 42.0869 11 40.9605 11H6.03952C4.91308 11 4 12.0192 4 13.2761V16.0346C5.46766 16.0346 6.65757 17.3623 6.65757 19C6.65757 20.6379 5.46766 21.9657 4 21.9657V25.5698C5.46766 25.5698 6.65757 26.8975 6.65757 28.5352C6.65757 30.1731 5.46766 31.5005 4 31.5005V34.7243C4 35.9812 4.91308 37 6.03952 37H40.9605C42.0869 37 43 35.9812 43 34.7243V31.5005C41.5323 31.5005 40.3424 30.1731 40.3424 28.5352Z" fill="#43D685" />
  </svg>
);

export default IconTicket1;
